// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_RemoveCompromissoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/removeCompromissoServico
 *
 * Deletes a compromisso_servico record and recalculates the compromisso total.
 *
 * Data shape: boolean true on success
 *
 * @see Compromissos_servicos::removeCompromissoServico()
 * @see Atendente_interactor::RemoveServicoCompromisso()
 * @see Compromissos_servicos_model::deleta_compromisso_servico()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CompromissosServicos_RemoveCompromissoServicoResponseDados = boolean;

export type CompromissosServicos_RemoveCompromissoServicoResponse = ApiResponse<CompromissosServicos_RemoveCompromissoServicoResponseDados>;

registerResponseContract('CompromissosServicos_RemoveCompromissoServicoResponse', {})
